import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './get-receipt-junior-pilot.actions';
import { GetReceiptJuniorPilotState } from './get-receipt-junior-pilot.state';

/**
 * getReceiptJuniorPilot initial state
 */
export const getReceiptJuniorPilotInitialState: GetReceiptJuniorPilotState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for GetReceiptJuniorPilot Store
 */
export const getReceiptJuniorPilotReducerFeatures: ReducerTypes<GetReceiptJuniorPilotState, ActionCreator[]>[] = [
  on(actions.setGetReceiptJuniorPilot, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateGetReceiptJuniorPilot, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetGetReceiptJuniorPilot, () => getReceiptJuniorPilotInitialState),

  on(actions.cancelGetReceiptJuniorPilotRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failGetReceiptJuniorPilot, (state, payload) =>
    asyncStoreItemAdapter.failRequest(state, payload.requestId)
  ),

  on(actions.setGetReceiptJuniorPilotFromApi, actions.updateGetReceiptJuniorPilotFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * GetReceiptJuniorPilot Store reducer
 */
export const getReceiptJuniorPilotReducer = createReducer(
  getReceiptJuniorPilotInitialState,
  ...getReceiptJuniorPilotReducerFeatures
);
